export const PROVIDER = {
    providerId: 1,
    providerName: "Casa del Café",
    isDelivery: false,
    showMethodPayHome: false, 
    showBarCode: true,
};